import React, { Component } from 'react';
import $ from 'jquery';
import {ApiClient} from '../libs/apiClient';
import moment from "moment";
import DetailsAuditoryModal from './DetailsAuditoryModal';
import { CURRENCY } from '../libs/utils/Const';
let apiClient = ApiClient.getInstance();
const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};

class InventoryStockModal extends Component{

    constructor(props) {
        super(props);
        this.state = {
            Asiento: [],
            getDetails :[]
        };
    }

    // componentWillReceiveProps = async ()=>{
    // }

    openDetails = async (event,indexRow) => {
        const {enableSpinner,FechaInicial,FechaFinal,ItemIn,ItemFi,showAlert,bandera,Group,wareHouses} = this.props;
        let Articulo = '';

        if(document.getElementById('btnSelector'+indexRow).click){
            Articulo = document.getElementById('btnSelector'+indexRow).value;
        }

        let FechaIni = moment(FechaInicial).format('YYYYMMDD');
        let FechaFin = moment(FechaFinal).format('YYYYMMDD');

        
        enableSpinner(true);
        let getDetails = '';
        if(!bandera){
            let data={
                Tipo : 'Details',
                FechaIn : FechaIni,
                FechaFi : FechaFin,
                Item : Articulo,
                GroupLis :Group,
                ItemInicial : ItemIn,
                ItemFinal : ItemFi,
            };
            
            getDetails = await apiClient.getAuditoryStock(data);
            
        }
        if(bandera){
            let data={
                Tipo : 'DetailsAccount',
                Item : Articulo,
                FechaIn : FechaIni,
                FechaFi : FechaFin
            };
            getDetails = await apiClient.getAuditoryStock(data);
            
        }
        if(wareHouses != '' && !bandera){
            let data={
                Tipo : 'WhsDetails',
                Item : Articulo,
                FechaIn : FechaIni,
                FechaFi : FechaFin,
                GroupLis :Group,
                Almacenes : wareHouses,
                ItemInicial : ItemIn,
                ItemFinal : ItemFi,
            };

            getDetails = await apiClient.getAuditoryWhs(data);
        }


        enableSpinner(false);
        if (getDetails.data.length === 0) {
            showAlert({type: 'info', message: 'Este artículo no cuenta con transacciones'});
            return;
        }
        if (getDetails.data.length === 1) {
            showAlert({type: 'info', message: 'Este artículo solo cuenta con una transaccion'});
            return;
        }

        $('#InventoryStockModal').modal('show');     
        

        this.setState({
            getDetails: getDetails.data
        });

        $('#DetailsAuditoryModal').modal('show');
        
    };

    closeConfirm = async () => {
        $('#InventoryStockModal').modal('hide');  
    }

    render() {
        const {getDetails} = this.state;
        const {ItemIn,ItemFi, newDatas,FechaInicial,FechaFinal,bandera,wareHouses} = this.props;
        let Items = ItemIn+"--"+ItemFi;
    // if(bandera){
    //     const resumen = newDatas.reduce((p,c)=>{ 
    //         p[c.InvntAct] = (p[c.InvntAct] || 0)+c.TransValue;  //,c.ItemName,c.TransValue
    //         // p[c.ItemName] = (p[c.ItemName] || '')
    //         console.log("con RETURN",p);
    //         return p;
    //     },{})
        
    //     const resultado = Object.keys(resumen).map(e=>{
    //         const o = {};
    //         o.InvntAct = e;
    //         // o.ItemName = e;
    //         o.TransValue = resumen[e];
    //         return o;
    //     })
    // }
    let whs = '';
        if(wareHouses ==='ALL' || wareHouses === ''){
            whs = 'TODOS'
        }

        let total = 0;
        newDatas.map(item => {
            total += Number(item.TransValue);
        })

        return (
            <div className="modal fade bd-example-modal-lg scroll bgtransparent" id="InventoryStockModal" style={{zIndex: 91}}
                 role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                     <DetailsAuditoryModal 
                     getDetails ={getDetails}/>
                <div className="modal-dialog modal-xl " role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{backgroundColor: '#343a40', borderRadius: '0'}}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                Informe de auditoría de stock
                            </h4>
                            <button type="button" className="close" onClick={this.closeConfirm} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="container">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <table className="table response" style={{marginBottom: 0}}>
                                                {/*HEADER*/}
                                                <div className="row" style={{paddingRight: 0}}>
                                                    {/*Primer columna*/}
                                                    <div className="col-sm col">
                                                        {/*DESDE*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">De fecha</span>
                                                            </div>
                                                            <input
                                                                    id="fechaInicio" 
                                                                    style={{
                                                                        important: true,
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                    }}
                                                                    disabled="true"
                                                                    className="form-control"
                                                                    type='date'
                                                                    placeholder="Fecha min"
                                                                    autoComplete="off"
                                                                    value={FechaInicial ? FechaInicial : ''}
                                                                    onChange={this.selectDocDueDate}
                                                                />
                                                        </div>
                                                        {/*Fecha de contabilización:*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Hasta fecha</span>
                                                            </div>
                                                            <input
                                                                    id="fechaFin"
                                                                    style={{
                                                                        important: true,
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                    }}
                                                                    disabled="true"
                                                                    className="form-control"
                                                                    type='date'
                                                                    placeholder="Fecha min"
                                                                    autoComplete="off"
                                                                     value={FechaFinal ? FechaFinal : ''}
                                                                     onChange={this.selectDocDate}
                                                                />
                                            
                                                            </div>
                                                                                                                
                                                    </div>
                                                    
                                                    {/*Segunda columna*/}
                                                    <div className="col-sm col">
                                                        {/*ARTICULOS*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Artículos</span>
                                                            </div>

                                                            <input
                                                                    id="fechaFin"
                                                                    style={{
                                                                        important: true,
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                    }}
                                                                    disabled="true"
                                                                    className="form-control"
                                                                    type='text'
                                                                    placeholder="Fecha min"
                                                                    autoComplete="off"
                                                                     value={Items ? Items : ''}
                                                                />
                                            
                                                            </div>

                                                        {/*ALMACENES*/}
                                                            <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Almacenes</span>
                                                            </div>
                                                            <input
                                                                    id="fechaFin"
                                                                    style={{
                                                                        important: true,
                                                                        backgroundColor: 'transparent',
                                                                        borderColor: '#ced4da',
                                                                        color: '#000',
                                                                    }}
                                                                    disabled="true"
                                                                    className="form-control"
                                                                    type='text'
                                                                    placeholder="Fecha min"
                                                                    autoComplete="off"
                                                                     value={wareHouses ? wareHouses : whs}
                                                                />
                                            
                                                            </div>                                         
                                                    </div>
                                                </div>
                                                {/*BODY*/}
                                                <div style={{marginBottom: 30}}>
                                                    <div style={{height: 400, overflow: 'auto'}}>
                                                        <table
                                                            // id="dataTableDocuments"
                                                            className="display"
                                                            style={{width: '100%',height:'200', marginBottom: 40, marginRight: -3000}}>
                                                            <thead className="table-header-yellow">
                                                                {!bandera ?
                                                                <tr style={{textAlign: "center"}}>
                                                                    <td className="sticky-column sticky-header" style={{width: '30%',backgroundColor: '#d2ab24'}}>
                                                                        Artículo
                                                                    </td>
                                                                    <td className="sticky-header" style={{width: '30%',backgroundColor: '#d2ab24'}}>
                                                                        Descripción
                                                                    </td>
                                                                    <td className="sticky-header" style={{width: '20%',backgroundColor: '#d2ab24'}}>
                                                                        Cantidad Acumulada
                                                                    </td>
                                                                    <td className="sticky-header" style={{width: '20%',backgroundColor: '#d2ab24'}}>
                                                                        Valor Acumulado
                                                                    </td>
                                                                </tr>:
                                                                <tr style={{textAlign: "center"}}>
                                                                    <td className="sticky-header" style={{width: '33%',backgroundColor: '#d2ab24'}}>
                                                                        Cuenta de mayor
                                                                    </td>
                                                                    <td className="sticky-header" style={{width: '33%',backgroundColor: '#d2ab24'}}>
                                                                        Nombre de la cuenta
                                                                    </td>
                                                                    <td className="sticky-header" style={{width: '33%',backgroundColor: '#d2ab24'}}>
                                                                        Valor Acumulado
                                                                    </td>
                                                                </tr>}
                                                            </thead>
                                                            <tbody>
                                                                {/* Filas de tabla  */}
                                                                
                                                                {newDatas.map((item, index) => {
                                                                    return (     
                                                                        <tr style={{
                                                                            maxHeight: 10,
                                                                            paddingTop: 8,
                                                                            paddingBottom: 8,
                                                                            // color: item.stock ? 'black' : 'red',
                                                                            backgroundColor: item.LineStatus ? 'rgb(210,210,210)' : 'transparent'}}>

                                                                            {/*articulo*/}
                                                                                <td
                                                                                    className="overflow-visible"
                                                                                    style={{textAlign: 'left', maxWidth: 800}}>
                                                                                    {index+1} &nbsp;
                                                                                    <button type="button" id={"btnSelector"+ index} value={item.ItemCode ? item.ItemCode : item.InvntAct} className="fas fa-arrow-circle-right" style={{backgroundColor: 'transparent', color: '#EABF28'}} onClick={event => this.openDetails(event,index)}>
                                                                                        
                                                                                    </button>  &nbsp;
                                                                                    {item.ItemCode ? item.ItemCode : item.InvntAct}
                                                                                </td>
                                                                            {/*descricpion/}*/}
                                                                            
                                                                                <td
                                                                                    className="overflow-visible"
                                                                                    style={{textAlign: 'center', maxWidth: 800}}>
                                                                                    {item.ItemName ? item.ItemName : item.AcctName}
                                                                                </td>
                                                                            
                                                                            {/*cantidad acumulada*/}
                                                                            {!bandera &&
                                                                                <td
                                                                                    className="overflow-visible"
                                                                                    style={{textAlign: 'center', maxWidth: 800}}>
                                                                                    {item.AcQty ? item.AcQty : '0'}
                                                                                </td>
                                                                            }   
                                                                            {/*valor*/}
                                                                                <td
                                                                                    className="overflow-visible"
                                                                                    style={{textAlign: 'center', maxWidth: 800}}>
                                                                                    {item.TransValue ? item.TransValue : '0'}
                                                                                </td>
                                                                        </tr>
                                                                    );
                                                                })}                
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>

{/* <div className="table-container" id="table-2">
  
  <table className="my-card-table">
    <thead>
      <tr className="my-card-table-heading">
        <th className="my-card-table-heading left-table-data" id="special-table-heading-first">Test</th>
        <th className="my-card-table-heading special-table-heading-middle">Start Date</th>
        <th className="my-card-table-heading special-table-heading-middle">Status</th>
        <th className="my-card-table-heading special-table-heading-last">Action</th>
      </tr>
    </thead>
    <tr className="my-card-table-row-grey">
      <td className="left-table-data">Test 3</td>
      <td className="">Sept 9, 2020</td>
      <td><a href="" className="my-card-link-2">Complete</a></td>
      <td><button className="take-test-button taken">Take Test</button></td>
    </tr>
    <tr data-submenu="1" className="my-card-table-row-white close-submenu">
      <td className="left-table-data">Test 4</td>
      <td className="">Sept 9, 2020</td>
      <td><a href="" className="my-card-link-2">In Progress</a></td>
      <td>
        <button className="take-test-button in-progress">Continue</button>
      </td>
    </tr>
    <tr data-submenu-element="1" className="submenu-list-container my-card-table-row-white submenu-item">
      <td className="left-table-data">Part 1 submenu</td>
      <td>Sept 9, 2020</td>
      <td>Complete</td>
      <td><a className="table-link complete-link" href="">Take Test</a></td>
    </tr>
    <tr data-submenu-element="1" className="submenu-list-container my-card-table-row-white submenu-item">
      <td className="left-table-data">Part 2 submenu</td>
      <td>Sept 9, 2020</td>
      <td>In Progress</td>
      <td><a className="table-link" href="">Take Test</a></td>
    </tr>
  </table>
</div> */}

                                                {/* FOOTER */}
                                                <div className="row" style={{paddingRight: 0}}>
                                                    {/*Primer columna*/}
                                                    <div className="col-sm col">                                                        
                                                        
                                                    </div>
                                                    
                                                    {/*Segunda columna*/}
                                                    <div className="col-sm col">
                                                        {/*Total*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">TOTAL Acumulado</span>
                                                            </div>

                                                            <input
                                                                id="fechaFin"
                                                                style={{
                                                                    important: true,
                                                                    backgroundColor: 'transparent',
                                                                    borderColor: '#ced4da',
                                                                    color: '#000',
                                                                    textAlign: 'right'
                                                                }}
                                                                className="form-control"
                                                                type='text'
                                                                placeholder="Fecha min"
                                                                autoComplete="off"
                                                                    value={formatNumber.new(total)}
                                                            />
                                                        </div>    
                                                    </div>
                                                </div>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeConfirm}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        );  
    }
}
export default InventoryStockModal;